import { simpleUserSchema } from "./userSchema";

export const userListSchema = [simpleUserSchema];
